import React from 'react';
import { useOutlet } from 'react-router-dom';

const MasterPagePublic = () => {
    const outlet = useOutlet();
    localStorage.clear();

    return (
        <React.Fragment>
            {outlet}
        </React.Fragment>
    );
};

export default MasterPagePublic;